import React, { useEffect, useState } from "react";
import "./VoiceOver.scss";
export default function VoiceOver(props) {
  const [html, setHtml] = useState(null);
  useEffect(() => {
    setHtml({ __html: props.content });
  }, [props.content]);
  return (
    <div
      className="voiceOver voiceOver-content"
      dangerouslySetInnerHTML={html}
    ></div>
  );
}
